<div >
    <input type="text" [ngClass]="modalOptions?.style" [(ngModel)]="locationName" autocorrect="off" autocapitalize="on" spellcheck="off"
       id="autocomplete" class="autocomplete form-control location-input"  #googleAutocomplete >
</div>

